import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, Sun as SunIcon, Moon } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { useAuth } from '../../contexts/auth-context';
import { useTheme } from '../../contexts/theme-context';
const Login = () => {
  const [username, setUsername] = useState('admin@rexonpower.com');
  const [password, setPassword] = useState('RexonPower@123');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    login
  } = useAuth();
  const {
    theme,
    toggleTheme
  } = useTheme();
  const navigate = useNavigate();
  const handleSubmit = async e => {
    e.preventDefault();
    if (!username || !password) {
      return;
    }
    setIsLoading(true);
    const success = await login(username, password);
    if (success) {
      navigate('/home');
    }
    setIsLoading(false);
  };
  return <div className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900 overflow-hidden">
      {/* Theme toggle */}
      <div className="absolute top-4 right-4 z-20">
        <Button variant="outline" size="icon" onClick={toggleTheme} className="rounded-full bg-white/10 backdrop-blur text-white border-white/20">
          {theme === 'light' ? <Moon className="h-4 w-4" /> : <SunIcon className="h-4 w-4" />}
        </Button>
      </div>

      {/* Background grid that fades near form */}
      <div className="absolute inset-0 pointer-events-none select-none opacity-25">
        <svg className="w-full h-full text-white/60" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
              <path d="M 10 0 L 0 0 0 10" fill="none" stroke="currentColor" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100" height="100" fill="url(#grid)" style={{ maskImage: 'radial-gradient(ellipse at 60% 50%, transparent 0%, transparent 40%, black 85%)', WebkitMaskImage: 'radial-gradient(ellipse at 60% 50%, transparent 0%, transparent 40%, black 85%)' }} />
        </svg>
      </div>

      {/* Centered form */}
      <div className="relative z-10 w-full max-w-md px-4">
        <Card className="border border-white/10 bg-white/80 dark:bg-gray-900/70 backdrop-blur-xl shadow-2xl">
          <CardHeader className="text-center space-y-2">
            <div className="mx-auto w-14 h-14 rounded-xl bg-blue-600/90 text-white flex items-center justify-center font-bold text-xl">R</div>
            <CardTitle className="text-2xl font-bold text-white">REXON POWER</CardTitle>
            <CardDescription className="text-blue-100">Sign in to your account to continue</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <label htmlFor="username" className="text-sm font-medium text-blue-100">Email</label>
                <Input id="username" type="email" placeholder="you@company.com" value={username} onChange={e=>setUsername(e.target.value)} required className="h-11 bg-white/90 dark:bg-gray-800/70 border-white/20 text-gray-900 dark:text-gray-100" />
              </div>
              <div className="space-y-2">
                <label htmlFor="password" className="text-sm font-medium text-blue-100">Password</label>
                <div className="relative">
                  <Input id="password" type={showPassword? 'text':'password'} placeholder="Enter your password" value={password} onChange={e=>setPassword(e.target.value)} required className="h-11 pr-10 bg-white/90 dark:bg-gray-800/70 border-white/20 text-gray-900 dark:text-gray-100" />
                  <Button type="button" variant="ghost" size="icon" className="absolute right-0 top-0 h-11 w-10 hover:bg-transparent" onClick={()=>setShowPassword(!showPassword)}>
                    {showPassword ? <EyeOff className="h-4 w-4 text-blue-100" /> : <Eye className="h-4 w-4 text-blue-100" />}
                  </Button>
                </div>
              </div>
              <Button type="submit" className="w-full h-11 bg-blue-600/90 hover:bg-blue-600 text-white font-medium" disabled={isLoading}>
                {isLoading ? 'Signing in...' : 'Sign In'}
              </Button>
              <p className="text-center text-xs text-blue-200 mt-2">Demo: admin@rexonpower.com / RexonPower@123</p>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>;
};
export default Login;

{/* no extra animations */}